<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更单号</label>
            <em class="weui-form-preview__value">{{form.main.sc_code}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{form.main.sa_custname}}</em>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务员</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.sa_seller}}
              <call-mobile :em-id="form.main.sa_sellerid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.sa_contact}} {{form.main.sa_tel}}
              <call-mobile :mobile="form.main.sa_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收货地址</label>
            <span class="weui-form-preview__value">{{form.main.sa_toplace}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收款方式</label>
            <span class="weui-form-preview__value">
              {{form.main.sa_payments}}
              <span v-if="form.main.sa_currency">{{form.main.sa_currency}}</span>
              <span v-if="form.main.sa_rate && form.main.sa_rate != 1">/ {{form.main.sa_rate}}</span>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单号</label>
            <span class="weui-form-preview__value">{{form.main.sc_sacode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.sa_pocode">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{form.main.sa_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单序号</label>
            <span class="weui-form-preview__value">{{form.main.sc_sdno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品编号</label>
            <span class="weui-form-preview__value">{{form.main.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{form.main.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_orispeccode">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{form.main.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_spec">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{form.main.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pr_brand">
            <label class="weui-form-preview__label">厂商/品牌</label>
            <span class="weui-form-preview__value">{{form.main.pr_brand}}</span>
          </div>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd"
        >
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <div class="weui-form-preview__value" v-if="form.main.sc_qty_old == form.main.sc_qty_new">
                <span>{{form.main.sc_qty_old}} {{form.main.pr_unit}}</span>
            </div>
            <div class="weui-form-preview__value" v-else>
                <span class="text-old">{{form.main.sc_qty_old}}</span>
                <span>-></span>
                <span class="text-new">{{form.main.sc_qty_new}} {{form.main.pr_unit}}</span>
            </div>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价</label>
            <div class="weui-form-preview__value" v-if="form.main.sc_price_old == form.main.sc_price_new">
                <span>{{form.main.sc_price_old}}</span>
            </div>
            <div class="weui-form-preview__value" v-else>
                <span class="text-old">{{form.main.sc_price_old}}</span>
                <span>-></span>
                <span class="text-new">{{form.main.sc_price_new}}</span>
            </div>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">税率</label>
            <div class="weui-form-preview__value" v-if="form.main.sc_taxrate_old == form.main.sc_taxrate_new">
                <span>{{form.main.sc_taxrate_old}}</span>
            </div>
            <div class="weui-form-preview__value" v-else>
                <span class="text-old">{{form.main.sc_taxrate_old}}</span>
                <span>-></span>
                <span class="text-new">{{form.main.sc_taxrate_new}}</span>
            </div>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <div class="weui-form-preview__value" v-if="form.main.sc_delivery_old == form.main.sc_delivery_new">
                <span v-format="'yyyy-MM-dd'">{{form.main.sc_delivery_old}}</span>
            </div>
            <div class="weui-form-preview__value" v-else>
                <span class="text-old" v-format="'yyyy-MM-dd'">{{form.main.sc_delivery_old}}</span>
                <span>-></span>
                <span class="text-new" v-format="'yyyy-MM-dd'">{{form.main.sc_delivery_new}}</span>
            </div>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更人</label>
            <span class="weui-form-preview__value">{{form.main.creatorName}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更原因</label>
            <span class="weui-form-preview__value">{{form.main.sc_reason}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [process],
  components: {
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/sale/change",
      caller: "SaleChange"
    };
  }
};
</script>

<style scoped>
.text-old {
    text-decoration: line-through;
    margin-right: 5px;
}

.text-new {
    color: #CE3C39;
    margin-left: 5px;
}
</style>